angular.module('ui.report.reportViewer', [])

    .directive('reportViewer', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/ui/report/reportViewer/reportViewer.html',
            scope: {},
            controller: 'ReportViewerController',
            controllerAs: 'ReportViewerController'
        }
    })

    .controller('ReportViewerController', function ($window, $scope, $rootScope, $q, $log, $sce, $http, $interval, gettextCatalog,
        authService, reportManager, orderItemsGridSharedSettings, gridDataProvider,
        usersRepository, workflowRepository, $customisationConfig, customResourceResolver,
        serverLocalization, uiLocalization, $state, $timeout) {
        var rootReportApi = om.config.build.baseUrl + "/report";
        var loadingHtml = $sce.trustAsHtml("<div class='loading'>" + gettextCatalog.getString("Loading...") + "</div>");
        var reportConfig = reportManager.getReportConfig();
        var reportQuery = (reportConfig.query || reportConfig.report.query);

        angular.extend($scope, {
            enableToolbar: enableToolbar,
            onPageChange: onPageChange,
            onActivate: onActivate,
            buildReport: buildReport,
            getReportDocument: getReportDocument,
            getDocumentProgress: getDocumentProgress,
            cancelDocument: cancelDocument,
            moveUp: moveUp,
            getReportParamsForUser: getReportParamsForUser
        });

        init();

        function init() {
            $scope.isBusy = true;
            $scope.selectedOrderItemId = orderItemsGridSharedSettings.getSelectedOrderItemId();

            var itemReportTitle = _.str.sprintf(gettextCatalog.getString('OM: Item %s Report: %s'), $scope.selectedOrderItemId, reportManager.getReportConfig().report.name);
            var itemsReportTitle = _.str.sprintf(gettextCatalog.getString('OM: Report: %s'), reportManager.getReportConfig().report.name);

            $rootScope.pageTitle = $scope.selectedOrderItemId ? itemReportTitle : itemsReportTitle;

            $scope.dataSource = new kendo.data.DataSource({
                data: [],
                pageSize: 1
            });
            $scope.exportOptions = {
                dataSource: [
                    { text: gettextCatalog.getString("Pdf"), value: "Pdf", selected: true },
                    { text: gettextCatalog.getString("Xls"), value: "Xls" },
                    { text: gettextCatalog.getString("Xlsx"), value: "Xlsx" },
                    { text: gettextCatalog.getString("Rtf"), value: "Rtf" },
                    { text: gettextCatalog.getString("Mht"), value: "Mht" },
                    { text: gettextCatalog.getString("Html"), value: "Html" },
                    { text: gettextCatalog.getString("Text"), value: "Text" },
                    { text: gettextCatalog.getString("Csv"), value: "Csv" },
                    { text: gettextCatalog.getString("Image"), value: "Image" }
                ],
                dataTextField: "text",
                dataValueField: "value"
            };
            $scope.exportFormat = "Pdf";
            $scope.step = orderItemsGridSharedSettings.getStepFilter() || 'all-open';

            $q.all([usersRepository.getCurrentUser(), gridDataProvider.getReportQuery()])
                .then(function (results) {
                    var user = results[0];
                    var gridDataProviderReportQuery = results[1];

                    //Double-check if the report was configured with dynamic query (function) and try to evaluate it
                    //passing the grid's query. Unfortunately we can't acquire selected item reference here, so omitting it.
                    if (angular.isFunction(reportQuery)) {
                        reportQuery = reportQuery(gridDataProviderReportQuery);
                    }

                    //See if the resulted report query is array of element IDs or not.
                    //If it is a string, we have to wrap it with double-quotes, otherwise - not.
                    if (!_.isArray(reportQuery)) {
                        reportQuery = '"' + reportQuery + '"';
                    } else {
                        reportQuery = '' + JSON.stringify(reportQuery) + '';
                    }

                    $scope.request = {
                        "ReportName": reportConfig.report.reportFileName,
                        "Query": reportQuery,
                        //we use either specific custom query of the report specified in customisation or
                        //just the query that is used to show the current data set user is being viewing at
                        //query and orderBy from report specified in customisation have higher priority over current-context data
                        "OrderBy": reportConfig.report.orderBy || reportConfig.orderBy,
                        "Format": "Html",
                        "BaseEntityName": reportConfig.report.baseEntityName,
                        "Parameters": $scope.getReportParamsForUser(user)
                    };

                    initStepHeader();

                    $scope.exportItems = {
                        items: [
                            {
                                template: "<a ng-click='moveUp(documentId)' class='order-state-link back-to-state' title='{{stateDisplayName}}'><span om-spinner size='0.6em' class='loading-spinner long-fade long-fade-in animation-v-align' ng-class='{out:(stateDisplayName && progress >= 100)}'></span><div ng-show='stateIconName' custom-background='{{stateIconName}}' class='order-state-link-icon fade fade-out' ng-class='{in:(stateDisplayName && progress >= 100)}'></div><div class='order-state-link-text fade fade-out' ng-class='{in:stateDisplayName}'>{{stateDisplayName}}</div><span class='fa fa-lg fa-level-up a-fa-btn'></span></a>",
                                overflow: "never"
                            },
                            { type: "separator" },
                            {
                                template: "<div kendo-pager='pager' id='report-pager' k-data-source='dataSource' k-numeric='false' k-info='false' k-input='true' k-on-change='onPageChange(this)'></div>",
                                overflow: "never"
                            },
                            { type: "separator" },
                            {
                                template: "<input kendo-drop-down-list k-options='exportOptions' style='width: 10em;' ng-model='exportFormat' />",
                                overflow: "never"
                            },
                            {
                                type: "button",
                                attributes: { "title": gettextCatalog.getString("Export a report and save it to the disk") },
                                imageUrl: "./assets/icons/save.png",
                                id: "saveExport"
                            },
                            {
                                type: "button",
                                attributes: { "title": gettextCatalog.getString("Export a report and show it in a new window") },
                                imageUrl: "./assets/icons/save-page.png",
                                id: "showExport"
                            },
                            { type: "separator" },
                            {
                                type: "button",
                                attributes: { "title": gettextCatalog.getString("PrintReport") },
                                imageUrl: "./assets/icons/print.png",
                                id: "printExport"
                            },
                            {
                                type: "button",
                                attributes: { "title": gettextCatalog.getString("PrintCurrentPage") },
                                imageUrl: "./assets/icons/print-page.png",
                                id: "printExportPage"

                            }
                        ],
                        click: function (e) {
                            switch (e.id) {
                                case "printExportPage":
                                case "printExport": {
                                    $scope.enableToolbar(false);
                                    var firstPage = (e.id === "printExportPage" ? $scope.pager.page() - 1 : 0);
                                    var lastPage = (e.id === "printExportPage" ? firstPage : $scope.dataSource.data().length - 1);
                                    $scope.getReportDocument($scope.documentId, "Html", firstPage, lastPage, null).then(function (data) {
                                        var printFrame = 
                                            $('<iframe id="print_frame" name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>')
                                            .appendTo('.report-container');
                                        var contentWindow = printFrame[0].contentWindow;
                                        if (angular.isDefined(contentWindow) && contentWindow != null) {
                                            contentWindow.onafterprint = function() {
                                                if (printFrame) {
                                                    printFrame
                                                        .remove(); //it's safe to remove the hidden frame now from the DOM
                                                }

                                                $timeout(function() {
                                                    $scope.enableToolbar(true);
                                                });
                                            };

                                            printFrame.contents().find('html').html(data);
                                            contentWindow.focus(); //for IE

                                            if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1 ||
                                                navigator.userAgent.toLowerCase().indexOf('edge') !== -1 ||
                                                navigator.userAgent.toLowerCase().indexOf('trident') !== -1) {
                                                contentWindow.document.execCommand('print', false, null);
                                            } else {
                                                contentWindow.print();
                                            }
                                        } else {
                                            $timeout(function () {
                                                $scope.enableToolbar(true);
                                            });
                                        }

                                    }, function (reason) {
                                        $timeout(function () {
                                            $scope.enableToolbar(true);
                                        });
                                        if (reason && 'FullException' in reason) {
                                            alert(reason.FullException);
                                        }
                                    });
                                    break;
                                }
                                case "saveExport": {

                                    $scope.enableToolbar(false);
                                    var form = $('<form method="POST" action="' + rootReportApi + '/document" target="iframe_target" style="display:none"><iframe id="iframe_target" name="iframe_target" src="about:blank"></iframe>');
                                    var params = {
                                        DocumentId: $scope.documentId,
                                        Format: $scope.exportFormat,
                                        FirstPage: 0,
                                        LastPage: $scope.dataSource.data().length - 1,
                                        ContentDisposition: "attachment",
                                        Authorization: authService.getToken()
                                    };
                                    $.each(params, function (k, v) {
                                        form.append($('<input type="hidden" name="' + k +
                                            '" value="' + v + '">'));
                                    });
                                    $('body').append(form);
                                    var document = $(window)[0].document;
                                    //document.cookie = "Authorization=" + authService.getToken() + "; path=/";
                                    document.cookie = "OMVersion=" + authService.omVersion + "; path=/";
                                    var options = {};

                                    form.submit(function () {
                                        $scope.enableToolbar(true);
                                    });
                                    form.submit();
                                    break;
                                }
                                case "showExport": {
                                    $scope.enableToolbar(false);

                                    var wnd = window.open("about:blank", "reportExport", "width=800.height=600");
                                    var form = $('<form method="POST" action="' + rootReportApi + '/document" target="blank">');
                                    var params = {
                                        DocumentId: $scope.documentId,
                                        Format: $scope.exportFormat,
                                        FirstPage: 0,
                                        LastPage: $scope.dataSource.data().length - 1,
                                        ContentDisposition: "inline",
                                        Authorization: authService.getToken()
                                    };
                                    $.each(params, function (k, v) {
                                        form.append($('<input type="hidden" name="' + k +
                                            '" value="' + v + '">'));
                                    });
                                    $('body').append(form);
                                    var document = $(window)[0].document;
                                    //document.cookie = "Authorization=" + authService.getToken() + "; path=/";
                                    document.cookie = "OMVersion=" + authService.omVersion + "; path=/";
                                    var options = {};
                                    form.attr('target', 'reportExport');
                                    form.submit(function () {
                                        $scope.enableToolbar(true);
                                    });

                                    form.submit();
                                    break;
                                }

                            }
                        }
                    };

                    //And finally trigger the routine that will build and show report
                    $scope.onActivate();
                });
        }

        function getReportParamsForUser(user) {
            var params = [];
            try {
                var dynamicTextLanguage = user.getCulture() || 'en-GB';
                var localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/London';

                params.push({ Name: 'dynamicTextLanguage', Value: dynamicTextLanguage });
                params.push({ Name: 'localTimezone', Value: localTimezone });
            } catch (error) {

            }

            return params;
        }

        function onPageChange() {
            $scope.enableToolbar(false);
            var page = $scope.pager.page() - 1;
            $scope.content = loadingHtml;
            $scope.getReportDocument($scope.documentId, "Html", page, page, null)
                .then(function (data) {
                    $scope.content = $sce.trustAsHtml("<div id='report-pages'>" + data + "</div>");
                    $scope.enableToolbar(true);
                }, function (reason) {
                    $scope.enableToolbar(true);
                    if (reason && 'FullException' in reason) alert(reason.FullException);
                });
        }

        function onActivate() {
            $scope.enableToolbar(false);
            $scope.content = loadingHtml;
            $scope.dataSource.data([]);
            $scope.buildReport()
                .then(function (data) {
                    $scope.content = $sce.trustAsHtml("<div id='report-pages'>" + data + "</div>");
                    $scope.enableToolbar(true);
                }, function (reason) {
                    $scope.enableToolbar(true);
                    if (reason && 'FullException' in reason) {
                        alert(reason.FullException);
                    }
                });
        }

        function buildReport() {
            $scope.cancelled = false;
            $scope.building = true;
            $scope.progress = 0;
            var deferred = $q.defer();

            $http({
                "url": rootReportApi + "/build",
                "method": "POST",
                "data": $scope.request,
                "headers": { "Content-Type": "application/json" }
            })
                .success(function (data, status, headers, config) {
                })
                .error(function (data, status, headers, config) {
                    if (status == 401) {
                        $log.error("Got 401 response from server on report build request.");
                        deferred.reject();
                    } else {
                        $log.error("Got error response from server on report build request: " + JSON.stringify(data));
                        deferred.reject(data);
                    }
                    $scope.building = false;
                }).then(function (data) {
                    var error = null;
                    $scope.documentId = data.data.documentId;
                    var interval = $interval(function () {
                        if (error != null || $scope.cancelled) {
                            //If we got error or cancellation requested
                            $interval.cancel(interval);
                            $scope.building = false;
                            if ($scope.cancelled) {
                                $scope.content = $sce.trustAsHtml("<div class='loading'>"
                                    + gettextCatalog.getString("Report generation cancelled.") + "</div>");
                            } else if (error != null) {
                                $log.error("Error during report generation: " + JSON.stringify(error));
                            }
                            deferred.reject(error);
                        } else if ($scope.progress >= 100) {
                            //stop polling for the report generation progress when it's ready
                            $interval.cancel(interval);
                            $log.debug("Report generation progress 100%. Cancelling progress polling.");
                            //and download the generated report
                            $scope.getReportDocument($scope.documentId, "Html", 0, 0, null).then(function (data) {
                                $log.debug("Generated report downloaded.");
                                deferred.resolve(data);
                                $scope.building = false;
                            });
                        } else {
                            //Keep asking the server for the report generation progress
                            $scope.getDocumentProgress($scope.documentId).then(function (result) {
                                if (result.progress !== -1) {
                                    if (result.progress >= $scope.progress) {
                                        $scope.progress = result.progress;
                                    }
                                    $log.debug("Report generation progress: " + result.progress);
                                } else {
                                    $scope.cancelled = result.cancelled;
                                    $log.debug("Report generation progress invalid. Cancelled report generation progress polling routine.");
                                }
                            }, function (reason) {
                                $log.error("Error during report generation progress request: " + JSON.stringify(reason));
                                error = reason;
                                deferred.reject(reason);
                                $scope.building = false;
                            });
                        }
                    }, 500);

                });
            return deferred.promise;
        }

        function getReportDocument(id, format, firstPage, lastPage, contentDisposition) {

            var deferred = $q.defer();
            var request = {
                "DocumentId": id,
                "Format": format,
                "FirstPage": firstPage,
                "LastPage": lastPage,
                "ContentDisposition": contentDisposition
            };
            $http({
                "url": rootReportApi + "/document",
                "method": "POST",
                "data": request,
                "headers": { "Content-Type": "application/json" }
            })
                .success(function (data, status, headers, config) {
                    deferred.resolve(data);
                })
                .error(function (data, status, headers, config) {
                    if (status == 401) {
                        $log.error("Got 401 response from server on generated report download request.");
                        deferred.reject();
                    } else {
                        $log.error("Error during generated report download: " + JSON.stringify(data));
                        deferred.reject(data);
                    }
                });
            return deferred.promise;
        }

        function getDocumentProgress(id) {

            var deferred = $q.defer();
            var request = {
                "DocumentId": id
            };
            $http({
                "url": rootReportApi + "/document/progress/" + encodeURIComponent(id),
                "method": "GET"
            })
                .success(function (data, status, headers, config) {
                    var pages = Array.apply(null, Array(data.pageCount)).map(function (x, i) {
                        return i;
                    });
                    $scope.dataSource.data(pages);
                    $scope.dataSource.page(1);

                    deferred.resolve(data);
                })
                .error(function (data, status, headers, config) {
                    if (status == 401) {
                        $log.error("Got 401 response from server on report generation progress request.");
                        deferred.reject();
                    } else {
                        $log.error("Got error response from server on report generation progress request.");
                        deferred.reject(data);
                    }
                });
            return deferred.promise;
        }

        function cancelDocument(id) {

            var deferred = $q.defer();
            var request = {
                "DocumentId": id
            };

            if (id) {
                $http({
                    "url": rootReportApi + "/document/cancel/" + encodeURIComponent(id),
                    "method": "GET"
                })
                    .success(function (data, status, headers, config) {
                        //do nothing here
                    })
                    .error(function (data, status, headers, config) {
                        if (status == 401) {
                            $log.error("Got 401 response from server on report generation cancel request.");
                            deferred.reject();
                        } else {
                            $log.error("Got error response from server on report generation cancel request.");
                            deferred.reject(data);
                        }
                    }).finally(function () {
                        $scope.cancelled = true;
                    });
            }
            return deferred.promise;
        }

        function enableToolbar(enable) {
            $scope.isBusy = !enable;
        }

        function initStepHeader() {
            $scope.stateDisplayName = "";
            $scope.stateIconName = "";

            return $q.all(
                [
                    usersRepository.getCurrentUser(),
                    workflowRepository.getSteps(),
                    customResourceResolver.resolveWorkflow()
                ]
            ).then(function (data) {
                var allSteps = data[1];
                var currentUser = data[0];
                var workflowConfig = data[2];
                var stepDisplayName = "All Items";

                var isCustomer = currentUser.isCustomer();
                var step = _.find(allSteps, function (s) {
                    return s.$model.code === $scope.step;
                });
                var stepConfig = _.find(workflowConfig.steps, function (s) {
                    return s.code === $scope.step;
                });

                if (step) {
                    stepDisplayName = isCustomer ? step.$model.publicNameResource : step.$model.nameResource;
                }

                var fallbackIconForStep = function (stepCode) {
                    if (stepCode === "all-open") {
                        return "track";
                    }
                    return $customisationConfig.hasResource(function (res) { return _.string.contains(res, stepCode + "."); }) ? stepCode : "workflow";
                };

                if ($scope.step && $scope.step !== "all-open") {
                    $scope.stateDisplayName = serverLocalization.translate(stepDisplayName);
                    $scope.stateIconName = angular.isUndefined(stepConfig) ? fallbackIconForStep($scope.step) :
                    (angular.isDefined(stepConfig.publicImageResourceName) && isCustomer
                        ? stepConfig.publicImageResourceName
                        :
                        (angular.isDefined(stepConfig.imageResourceName) ? stepConfig.imageResourceName :
                            fallbackIconForStep($scope.step)));
                } else {
                    var customFilter = orderItemsGridSharedSettings.getCustomFilter();
                    if (customFilter) {
                        $scope.stateDisplayName = gettextCatalog.getString(customFilter.name || "Filtered Items");
                        $scope.stateIconName = customFilter.iconName || fallbackIconForStep($scope.step);
                    } else {
                        $scope.stateDisplayName = gettextCatalog.getString("All Items");
                        $scope.stateIconName = fallbackIconForStep($scope.step);
                    }
                }
                
            });
        }

        function moveUp(documentId) {
            if (documentId && $scope.progress < 100) {
                //Cancel report generation if it's not generated yet
                $scope.cancelDocument(documentId);
            }
            if (reportConfig.backAction) {
                reportConfig.backAction();
            } else {
                //$state.go('client.orders', { step: $scope.step });
                $window.history.back();
            }
        }
    })

    ;
